import React, { Component } from 'react'
import { Link } from 'react-router'
import Newsletter from '../../containers/NewsletterWidget'
import News from '../PageHome/components/Noticias'
import Neighborhood from '../PageResidential/components/Neighborhoods/Neighborhoods.container'
import Imis from '../commons/SliderMarketReports/imi'
import { translate } from "react-translate"

@translate("Barrio")
export default class NeighborhoodList extends Component {

  componentWillMount() {
    this.props.didMount({ id: '6', name: 'Residencial'});
    window.scrollTo(0, 0)
  }

  componentDidMount(){
    window.location.hash = window.decodeURIComponent(window.location.hash);
    const scrollToAnchor = () => {
      const hashParts = window.location.hash.split('#');
      if (hashParts.length === 2) {
        const hash = hashParts.slice(-1)[0];
        document.querySelector(`#${hash}`).scrollIntoView();
      }
    };
    scrollToAnchor();
    window.onhashchange = scrollToAnchor;
  }

  render () {

    const { relevantsList, newsList, directors, imis, t } = this.props;
    
    let baseUrl = window.location.origin;
    let barriosUrl = baseUrl + '/barrios';
    
    return (
    	<div className="neighborhoods-landing container-fluid">    
        <ol className="route-info hidden-xs" itemScope itemType="http://schema.org/BreadcrumbList">
          <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
            <a href={ baseUrl } itemProp="item" itemType="http://schema.org/Thing">
              <span itemProp="name"><small>{t("Informacion_Novedades")}</small></span>
              <meta itemProp="position" content="1" />
            </a>
          </li>
          
          <i className="fa fa-angle-right"></i>
          
          <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
            <a href={ barriosUrl } itemProp="item" itemType="http://schema.org/Thing">
              <span itemProp="name"><small>{t("Barrios")}</small></span>
              <meta itemProp="position" content="2" />
            </a>
          </li>
        </ol>
        
        <div className="neighborhoods-container" id="barrios" name="barrios">
          <h1>Barrios</h1>
          <Neighborhood />
        </div>
        {(imis.length > 0) ?
          <div className="imis-container">
            <Imis imis={imis}/>
          </div> : '' }
        <div className="form-newsletter-container">
          <Newsletter />
        </div>
        {(newsList.length > 0) ?
          <News news={newsList} />
        : '' }
    	</div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/PageNeighborhoods/PageNeighborhoods.component.js